module.exports = __webpack_public_path__ + "img/qr1.39e98dac.png";